module.exports = __webpack_public_path__ + "img/strip.2bb0abb9.png";